import * as InlineEdit from "@/components/InlineEdit";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { useEditOrganization } from "@/queries/organizations";

const OrganizationName = () => {
  const authContext = useAuth();
  const userToken = authContext!.userToken;
  const currentOrganization = useActiveOrganization()!;
  const { mutateAsync: editOrganization } = useEditOrganization(userToken!);

  const handleEditOrganizationName = (newTitle: string) => {
    editOrganization({
      organizationId: currentOrganization.id,
      name: newTitle,
    });
  };

  return (
    <InlineEdit.Root
      initialValue={currentOrganization.name}
      onEdit={handleEditOrganizationName}
    >
      <InlineEdit.Trigger>
        <h1 className="text-2xl font-bold">{currentOrganization.name}</h1>
      </InlineEdit.Trigger>
      <InlineEdit.Input />
      <InlineEdit.Rename>Save</InlineEdit.Rename>
      <InlineEdit.Cancel>Cancel</InlineEdit.Cancel>
    </InlineEdit.Root>
  );
};

export default OrganizationName;
